module.exports = __webpack_public_path__ + "img/Blauzahn.c1952347.svg";